export default "__VITE_ASSET__DeM3Q7gm__"